<template>
  <!--
            event içinde etkilenen data olduğunda bütün fonksiyonların çalışmasının engellenmesi için
            Dataların computed olarak return ettirilmesi ve vue içinde bu şekilde kullanılması gerekmektedir.

           Schedule
           User ekranları
           bunun yanında (!-- WeatherMatrix, Airport, Aircraft, FIRs, Ipadpreview, DataTransferScreen --)
           Eventlere girildiğinde computed üzerinden dönüp işlemin sonucunda eğer problem yapıyorsa hatanın düzeltilmesi.

    -->

  <div>
    <div class="modal" :class="{ 'is-active': isActiveEFBReportModal }">
      <div class="modal-background" @click="CloseReportModalFunc()"></div>

      <div
        class="modal-content animate__animated animate__zoomIn animate__faster"
      >
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <h2 class="modal-title">{{headerFlightText}} - EFB Flight Report</h2>
              <p class="flight-info">{{ activeFkeyForZip }}</p>
            </div>
            <button class="close-btn" @click="CloseReportModalFunc()">
              <font-awesome-icon icon="times" />
            </button>
          </div>
        </div>

        <div class="modal-card-body">
          <div class="columns is-gapless card-columns">
            <div class="column is-3 file-sidebar">
              <div class="device-section" v-if="DeviceUid1Files">
                <div
                  @click="
                    renderReportPDF(
                      activeFkeyForZip,
                      DeviceUid1Files.deviceUID,
                      activeFlightData.std,
                      activeFlightData.flightArchiveStat
                    ),
                      (IsPdfRender = true)
                  "
                  class="file-item"
                  :class="{
                    'is-active':
                      idOfPdf ==
                      DeviceUid1Files.deviceUID +
                        '_' +
                        DeviceUid1Files.reportFileName,
                  }"
                >
                  <div class="file-icon">
                    <img
                      v-if="
                        DeviceUid1Files.reportFileName
                          .toUpperCase()
                          .includes('.PDF')
                      "
                      src="../../assets/images/pdf.png"
                      height="24"
                      width="24"
                    />

                    <img
                      v-else
                      src="../../assets/images/cameraColor .png"
                      height="24"
                      width="24"
                    />
                  </div>
                  <p class="file-item-name">Report.Pdf</p>
                </div>

                <div
                  v-for="(filename, index) in DeviceUid1Files.listFileNames"
                  :key="index"
                  @click="
                    renderReportImage(
                      DeviceUid1Files.deviceUID,
                      filename,
                      DeviceUid1Files.aL_BT_Type
                    )
                  "
                  class="file-item"
                  :class="{
                    'is-active':
                      idOfPdf == DeviceUid1Files.deviceUID + '_' + filename,
                  }"
                >
                  <div class="file-icon">
                    <img
                      v-if="filename.toUpperCase().includes('.JPG')"
                      src="../../assets/images/cameraColor .png"
                      height="24"
                      width="24"
                    />

                    <img
                      v-else
                      src="../../assets/images/pdf.png"
                      height="24"
                      width="24"
                    />
                  </div>
                  <p class="file-item-name">{{ filename }}</p>
                </div>
              </div>

              <div class="device-section" v-if="DeviceUid2Files">
                <div
                  @click="
                    renderReportPDF(
                      activeFkeyForZip,
                      DeviceUid2Files.deviceUID,
                      activeFlightData.std,
                      activeFlightData.flightArchiveStat
                    ),
                      (IsPdfRender = true)
                  "
                  class="file-item"
                  :class="{
                    'is-active':
                      idOfPdf ==
                      DeviceUid2Files.deviceUID +
                        '_' +
                        DeviceUid2Files.reportFileName,
                  }"
                >
                  <div class="file-icon">
                    <img
                      v-if="
                        DeviceUid2Files.reportFileName
                          .toUpperCase()
                          .includes('.PDF')
                      "
                      src="../../assets/images/pdf.png"
                      height="24"
                      width="24"
                    />
                    <img
                      v-else
                      src="../../assets/images/cameraColor .png"
                      height="24"
                      width="24"
                    />
                  </div>

                  <p class="file-item-name">Report.Pdf</p>
                </div>

                <div
                  v-for="(filename, index) in DeviceUid2Files.listFileNames"
                  :key="index"
                  @click="
                    renderReportImage(
                      DeviceUid2Files.deviceUID,
                      filename,
                      DeviceUid2Files.aL_BT_Type
                    )
                  "
                  class="file-item"
                  :class="{
                    'is-active':
                      idOfPdf == DeviceUid2Files.deviceUID + '_' + filename,
                  }"
                >
                  <!--  @click=""  buraya dosya ismi parametre olarak verilip tıklandığında render etmesi için -->
                  <div class="file-icon">
                    <img
                      v-if="filename.toUpperCase().includes('.JPG')"
                      src="../../assets/images/cameraColor .png"
                      height="24"
                      width="24"
                    />

                    <img
                      v-else
                      src="../../assets/images/pdf.png"
                      height="24"
                      width="24"
                    />
                  </div>
                  <p class="file-item-name">{{ filename }}</p>
                </div>
              </div>

              <div class="device-section" v-if="DeviceUid3Files">
                <div
                  @click="
                    renderReportPDF(
                      activeFkeyForZip,
                      DeviceUid3Files.deviceUID,
                      activeFlightData.std,
                      activeFlightData.flightArchiveStat
                    ),
                      (IsPdfRender = true)
                  "
                  :class="{
                    'is-active':
                      idOfPdf ==
                      DeviceUid3Files.deviceUID +
                        '_' +
                        DeviceUid3Files.reportFileName,
                  }"
                  class="file-item"
                >
                  <div class="file-icon">
                    <img
                      v-if="
                        DeviceUid3Files.reportFileName
                          .toUpperCase()
                          .includes('.PDF')
                      "
                      src="../../assets/images/pdf.png"
                      height="24"
                      width="24"
                    />

                    <img
                      v-else
                      src="../../assets/images/cameraColor .png"
                      height="24"
                      width="24"
                    />
                  </div>
                  <p class="file-item-name">Report.pdf</p>
                </div>

                <div
                  v-for="(filename, index) in DeviceUid3Files.listFileNames"
                  :key="index"
                  @click="
                    renderReportImage(
                      DeviceUid3Files.deviceUID,
                      filename,
                      DeviceUid3Files.aL_BT_Type
                    )
                  "
                  class="file-item"
                  :class="{
                    'is-active':
                      idOfPdf == DeviceUid3Files.deviceUID + '_' + filename,
                  }"
                >
                  <div class="file-icon">
                    <img
                      v-if="filename.toUpperCase().includes('.JPG')"
                      src="../../assets/images/cameraColor .png"
                      height="24"
                      width="24"
                    />

                    <img
                      v-else
                      src="../../assets/images/pdf.png"
                      height="24"
                      width="24"
                    />
                  </div>
                  <p class="file-item-name">{{ filename }}</p>
                </div>
              </div>
            </div>

            <div class="column is-9 preview-area">
              <div v-if="!idOfPdf" class="empty-state">
                <div class="empty-state-icon">
                  <font-awesome-icon :icon="['far', 'file']" size="4x" />
                </div>
                <h3 class="empty-state-title">No file selected</h3>
                <p class="empty-state-text">
                  Select a file from the list to preview
                </p>
              </div>

              <div v-else-if="IsPdfRender" class="preview-container">
                <embed
                  type="application/pdf"
                  :src="getPdfStreamUrl"
                  width="100%"
                  height="100%"
                  alt="pdf"
                  internalinstanceid="21"
                  title="CHROME"
                />
              </div>

              <div v-else class="preview-container">
                <div class="image-wrapper">
                  <img
                    v-if="Jpegshow"
                    :src="getImageStreamUrl"
                    @error="errorjpeg(0)"
                    @load="errorjpeg(1)"
                    onerror="this.style.display='none'"
                    :alt="getImageStreamUrl"
                    class="preview-image"
                  />

                  <p v-else class="error-message">Image couldn't be loaded</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { loadingMixin } from "../../utils/mixins";
// import LoadingButton from "./LoadingButton";

export default {
  name: "EFBReportModal",
  // aktifurl olarak değişim durumu sözkonusu DeviceUID1, DeviceUID2, bunların alt kırılımı olarak Reportpdf ve imagesların gösterimi var.

  props: ["activeUrl", "activeFKey", "headerFlightText"],
  data() {
    return {
      modalsize: {
        width: "70%",
        height: "80%",
      },
      isloadedstat: 0,
      isImageOrPdfRendered: false,
      idOfPdf: "",
      IsPdfRender: false,
      ActiveDevice_UID: "",
      ActiveFlightArchiveId: -1,
      ActiveDeviceALBTPrefix: "",
      ActiveJpegName: "",
      Jpegshow: true,
      imageZoom: 100,
    };
  },

  computed: {
    ...mapState("schedule", [
      "activeFkeyForZip",
      "activeFlightData",
      "reportImageModalUrl",
      "reportPdfModalUrl",
    ]),

    ...mapState("schedule", [
      "isActiveEFBReportModal",
      "activeFlightBasedReportFiles",
      /* bu kısım parametrik olrak KFZ,Legno ihtiyaç ne ise doldurulacak nedeni ilgili uçuşun input reports ve images ları alınması gerekmektedir */
      /* Alınacak images bilgileri ile  */
    ]),

    Comprendercomponentstat: {
      get() {
        if (this.isActiveEFBReportModal == true) {
          return 1;
        } else {
          return 0;
        }
      },
    },

    DeviceUid1Files: {
      get() {
         if (!this.activeFlightBasedReportFiles || !this.activeFlightData) {
          return null;
        } 
        return this.activeFlightBasedReportFiles.find(
          (x) => x.deviceUID == this.activeFlightData.devicE_UUID1
        );
      },
    },

    DeviceUid2Files: {
      get() {
        if (!this.activeFlightBasedReportFiles || !this.activeFlightData) {
          return null;
        }
        return this.activeFlightBasedReportFiles.find(
          (x) => x.deviceUID == this.activeFlightData.devicE_UUID2
        );
      },
    },

    DeviceUid3Files: {
      get() {
        if (!this.activeFlightBasedReportFiles || !this.activeFlightData) {
          return null;
        }
        return this.activeFlightBasedReportFiles.find(
          (x) => x.deviceUID == this.activeFlightData.devicE_UUID3
        );
      },
    },

    getPdfStreamUrl: {
      get() {
        if (!this.activeFlightData) {
          return "";
        }
        return (
          this.reportPdfModalUrl +
          this.activeFkeyForZip +
          "/" +
          this.activeFlightData.std +
          "/" +
          this.ActiveDevice_UID +
          "/" +
          0
        );
      },
    },

    getImageStreamUrl: {
      get() {
        if (!this.activeFlightData) {
          return "";
        }
        return (
          this.reportImageModalUrl +
          this.activeFkeyForZip +
          "/" +
          this.activeFlightData.std +
          "/" +
          this.ActiveDevice_UID +
          "/" +
          this.ActiveJpegName +
          "/" +
          this.ActiveDeviceALBTPrefix +
          "/" +
          0
        );
      },
    },
  },

  asynccomputed: {},

  async created() {},

  mixins: [loadingMixin],

  components: {
    // LoadingButton,
  },

  methods: {
    ...mapActions("schedule", [
      "showEFBReportModal",
      "closeEFBReportModal",
      "GetEFBReportFiles",
    ]),

    errorjpeg(stat) {
      if (stat == 0) {
        this.Jpegshow = false;
      } else if (stat == 1) {
        this.Jpegshow = true;
      }
    },

    renderReportPDF(KFZ, DeviceUID, STD, flightArchiveStat) {
      console.log(KFZ, DeviceUID, STD);
      const deviceFile = this.activeFlightBasedReportFiles.find(
        (x) => x.deviceUID == DeviceUID
      );

      if (deviceFile) {
        this.idOfPdf = DeviceUID + "_" + deviceFile.reportFileName;
      }
      this.ActiveDevice_UID = DeviceUID;
      this.ActiveFlightArchiveId = flightArchiveStat;
      this.IsPdfRender = true;

      //activeFkeyForZip,DeviceUid2Files.deviceUID,activeFlightData.std
    },

    renderReportImage(DeviceUID, JpegName, AL_BT_Type) {
      this.ActiveDevice_UID = DeviceUID;
      this.idOfPdf = DeviceUID + "_" + JpegName;
      //this.ActiveDeviceALBTPrefix = this.DeviceUid2Files.aL_BT_Type;
      this.ActiveDeviceALBTPrefix = AL_BT_Type;
      this.ActiveJpegName = JpegName;
      this.IsPdfRender = false;
    },

    resetModalState() {
      this.idOfPdf = "";
      this.IsPdfRender = false;
      this.ActiveDevice_UID = "";
      this.ActiveFlightArchiveId = -1;
      this.ActiveDeviceALBTPrefix = "";
      this.ActiveJpegName = "";
      this.Jpegshow = true;
      this.imageZoom = 100;
    },

    CloseReportModalFunc() {
      this.isloadedstat = 0;
      this.resetModalState();
      this.$emit("closeEFBReportModal");
    },

    fullscreenModal() {
      (this.modalsize.width = "100%"), (this.modalsize.height = "100%");
    },

    defaultScreenModal() {
      (this.modalsize.width = "70%"), (this.modalsize.height = "50%");
    },

    async getFileFullNames(KFZ, STD, DeviceUID) {
      await this.GetEFBReportFiles(KFZ, STD, DeviceUID);
    },

    openNewTab() {
      window.open(this.activeUrl, "Image", "resizable=1");
    },

    isloaded(stat) {
      this.isloadedstat = stat;
    },
  },

  mounted() {
    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 27) {
        //ESC
        this.isloadedstat = 0;
        this.$emit("closeEFBReportModal");
        // this.$emit('closeEFBReportModal');
      }
    });
  },

  watch: {
    activeFkeyForZip(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetModalState();
      }
    },
  },
};
</script>

<style scoped>
.modal-content {
  border-radius: 16px;
  width: 90%;
  max-width: 1500px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  position: relative;
}

.modal-header {
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  padding: 20px 32px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 4px 0;
}

.flight-info {
  font-size: 18px;
  color: #555;
}

.close-btn {
  font-size: 18px;
  background: transparent;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  color: #6b7280;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: #f3f4f6;
  color: #111827;
}

.card-columns {
  height: 100%;
}

.file-sidebar {
  border-right: 1px solid #e5e7eb;
  overflow-y: auto;
  height: 100%;
}

.device-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-right: 10px;
}

.device-label {
  font-size: 16px;
  font-weight: 600;
  color: #555;
}

.device-uid {
  font-size: 18px;
  font-family: monospace;
  word-break: break-all;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.file-item:hover {
  background: #f2f3f5;
}

.file-item.is-active {
  background: #f2f3f5;
}

.file-icon {
  width: 40px;
  height: 40px;
}

.file-item-name {
  font-size: 14px;
  font-weight: 500;
}

.preview-area {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow-y: auto;
}

.empty-state {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.empty-state-icon {
  color: #555;
}

.empty-state-title {
  font-size: 20px;
  font-weight: 600;
  margin-top: 20px;
}

.empty-state-text {
  font-size: 14px;
  color: #6b7280;
}

.preview-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}

.image-wrapper {
  width: 100%;
  height: 100%;
  align-items: flex-start;
}

.preview-image {
  display: block;
  width: auto;
  height: auto;
  object-fit: contain;
  transform-origin: top center;
  transition: transform 0.2s ease;
}

.error-message {
  color: #dc2626;
  font-size: 14px;
  text-align: center;
}
</style>
